import React from "react";
import Navb from "../../../../components/navbar/Navb";
import Footer from "../../../../components/footer/Footer";
import RecipiePage from "../../../../components/recipiePage/RecipiePage";
import Recpiesimg1 from "./recpiesimg1.png";
import Recpiesimg2 from "./recpiesimg2.png";
import Recpiesimg3 from "../../img4.png";
import Recpiesimg4 from "../../img3.png";
import Recpiesimg5 from "../../img11.png";
import Img1 from "./img1.png";
import Timer from "../timer.png";
import "../recipe.css";
const Nandisabjimasala = () => {
  return (
    <>
      <RecipiePage
        Recpiesimg1={Recpiesimg1}
        Recpiesimg2={Recpiesimg2}
        Recpiesimg3={Recpiesimg3}
        Recpiesimg4={Recpiesimg4}
        Recpiesimg5={Recpiesimg5}
        Img1={Img1}
        Name="Nandi Sabji Masala"
        Ul1={
          <ul>
            <li>
            <span className="Bold">Nandi Sabji Masala</span>
            </li>
            <li>
            Assorted vegetables (carrots, 
            </li>
            <li>
            beans, peas, potatoes, etc.) 
            </li>
            <li>oil or ghee</li>
            <li>onion, finely chopped</li>
            <li>tomatoes, chopped </li>
           
          </ul>
        }
        Ul2={
          <ul className="noDecoration">
            <li>as per taste</li>
            <li>2 tablespoons</li>
            <li>1 large </li>
            <li> 2 piece</li>
            <li>1 tablespoon</li>
            <li>to taste</li>
          </ul>
        }
        Ul3={
          <ul>
            <li>coriander leaves for garnish</li>
            <li>Ginger Garlic Paste </li>
          </ul>
        }
        Ul4={
          <ul className="noDecoration">
            <li>Fresh</li>
          </ul>
        }
        Ol1={
          <ol>
            <li>
              Heat oil or ghee in a pan. Add chopped onions and sauté until
              golden brown.
            </li>
            <li>
              Add ginger-garlic paste and sauté until the raw smell disappears.
            </li>
            <li>
              Add chopped tomatoes and cook until they are soft and the oil
              starts to separate.
            </li>
            <li>Add the assorted vegetables and stir well.</li>
            <li>
              Sprinkle Nandi Sabji Masala over the vegetables. Adjust the
              quantity based on your taste preferences and the masala's
              intensity.
            </li>
            <li>
              Stir in salt and cook the vegetables until they are tender but
              still have a slight crunch.
            </li>
            <li>Garnish with fresh coriander leaves.</li>
            <li>
              Serve the Nandi Sabji Masala Stir-Fry hot with roti or rice.
            </li>
          </ol>
        }
        Item1="Maida Veg Pizza Cones"
        Item2="Whole Atta Cookies"
        Item3="Dalia Khichadi"
        Link1="maidavegpizzacones"
        Link2="wholeattacookies"
        Link3="daliakhichadi"
      />
      {/* <Navb />
      <div className="singleRecipeTop">Nandi Sabji Masala</div>
      <img className="singleRecipeTopimg" src={Recpiesimg1} alt="Recpiesimg1" />
      <div className="singleRecipeBot">
        <div className="singleRecipeBotLeftItems">
          <div className="singleRecipeBotLeftItemTitle">INGREDIENTS</div>
          <hr />
          <div className="singleRecipeBotLeftItem">
            <ol>
              <li>
                Assorted vegetables (carrots, beans, peas, potatoes, etc.),
                chopped
              </li>
              <li>2 tablespoons oil or ghee</li>
              <li>1 large onion, finely chopped</li>
              <li>2 tomatoes, chopped</li>
              <li>1 tablespoon ginger-garlic paste</li>
              <li>
                <span className="Bold">Nandi Sabji Masala (as per taste)</span>
              </li>
              <li>Salt to taste</li>
              <li>Fresh coriander leaves for garnish</li>
            </ol>
          </div>

          <hr />
          <div className="flexitemrecipe">
            <img src={Recpiesimg2} alt="Recpiesimg2" />
            Nandi Sabji Masala
          </div>
        </div>
        <div className="singleRecipeBotRight">
          <div className="singleRecipeBotRightTop">Instructions</div>
          <ol>
            <li>
              Heat oil or ghee in a pan. Add chopped onions and sauté until
              golden brown.
            </li>
            <li>
              Add ginger-garlic paste and sauté until the raw smell disappears.
            </li>
            <li>
              Add chopped tomatoes and cook until they are soft and the oil
              starts to separate.
            </li>
            <li>Add the assorted vegetables and stir well.</li>
            <li>
              Sprinkle Nandi Sabji Masala over the vegetables. Adjust the
              quantity based on your taste preferences and the masala's
              intensity.
            </li>
            <li>
              Stir in salt and cook the vegetables until they are tender but
              still have a slight crunch.
            </li>
            <li>Garnish with fresh coriander leaves.</li>
            <li>
              Serve the Nandi Sabji Masala Stir-Fry hot with roti or rice.
            </li>
          </ol>
        </div>
      </div>
      <div className="singleRecipeEnd">
        <div className="singleRecipeEndTitle">You Might Also Like</div>
        <div className="singleRecipeEndItems">
          <div className="singleRecipeEndItem">
            <div className="singleRecipeEndItemTop">
              <a href="/recipes/besankadhirice">
                <img src={Recpiesimg3} alt="Recpiesimg3" />
                <div className="singleRecipeEndItemTitle">
                  Besan Kadhi & Rice
                </div>
              </a>
            </div>
            <div>
              <img src={Timer} alt="Timer" />
              <span>Ready in 30 mins</span>
            </div>
          </div>
          <div className="singleRecipeEndItem">
            <div className="singleRecipeEndItemTop">
              <a href="/recipes/nandimeatmasalacurry">
                <img src={Recpiesimg4} alt="Recpiesimg4" />
                <div className="singleRecipeEndItemTitle">
                  Nandi Meat Masala Curry
                </div>
              </a>
            </div>
            <div>
              <img src={Timer} alt="Timer" />
              <span>Ready in 50 mins</span>
            </div>
          </div>
          <div className="singleRecipeEndItem">
            <div className="singleRecipeEndItemTop">
              <a href="/recipes/daliakhichadi">
                <img src={Recpiesimg5} alt="Recpiesimg5" />
                <div className="singleRecipeEndItemTitle">Dalia Khichadi</div>
              </a>
            </div>
            <div>
              <img src={Timer} alt="Timer" />
              <span>Ready in 20 mins</span>
            </div>
          </div>
        </div>
      </div>
      <Footer /> */}
    </>
  );
};

export default Nandisabjimasala;
